import script from "./TabBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabBar.vue?vue&type=script&lang=ts&setup=true"

import "./TabBar.vue?vue&type=style&index=0&id=27d5891b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d5891b"]])

export default __exports__